import { plainToInstance, Type } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { localizedStrings } from '@core/strings'
import {
  DetectedObjects,
  TemplateWarningItemTypes,
  TemplateWarningTypes,
} from '@core/entities/template/TemplateWarnings/types'
import {
  IImageWarning,
  WarningDetails,
  TriggerType,
} from '@core/entities/ImageWarning'

export class ImageWarning extends Entity<IImageWarning> {
  id?: string

  type: TemplateWarningTypes

  text: string

  present: boolean

  feedbackProvided: boolean

  templateId?: string

  questionId?: string

  @Type(() => WarningDetails)
  details?: WarningDetails

  downloadUrls?: Array<string>

  detectedObjects?: DetectedObjects

  itemTypes?: TemplateWarningItemTypes

  triggerType: TriggerType

  errors?: {
    typeErrors?: Array<{ error: string }>
  }

  public static new(payload: unknown): ImageWarning {
    const entity = plainToInstance(ImageWarning, payload)

    return entity
  }

  public getTitle(): string {
    const titleMap: Record<TemplateWarningTypes, string> = {
      CLONED_PERMIT: localizedStrings.clonedPermitDetected,
      IMAGE_DUPLICATE: localizedStrings.duplicateImagesDetected,
      IMAGE_OBJECT_DETECTION: localizedStrings.hazardDetected,
    }

    return titleMap[this.type] ?? localizedStrings.warningDetected
  }

  public static showProofWarningIcon(
    warnings: ImageWarning[],
    proofKey: string,
  ) {
    return warnings?.some((warning) => {
      if (warning.type === 'IMAGE_DUPLICATE') {
        return warning.details.duplicates.some(
          (duplicate) => duplicate.mediaKey === proofKey,
        )
      }

      if (warning.type === 'IMAGE_OBJECT_DETECTION') {
        return warning.detectedObjects?.[proofKey].some((detection) => {
          if (warning.triggerType === 'PRESENT_ITEMS') {
            return detection.present
          } else {
            return true // If we're looking for missing object, then all the images should have ⚠️  since it means the object is not in any of the images
          }
        })
      }

      return false
    })
  }
}
